import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import assetTransferService from "../../../../services/web/asset-transfer-service.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const AssetTransferList = () => {
    const navigate = navigateHook();

    const [filter, setFilter] = useState([])
    const [state, setState] = useState("")
    const gridRef = useRef(null);
    const theme = useMemo(() => aggridUtils.generalTheme(), []);

    const columnDefs = [
        {headerName: "Data/hora", field: "date", flex: 1, width: 130, comparator: aggridUtils.agGridCompareDateTime},
        {headerName: "Ativo", field: "asset", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "Local de origem", field: "place", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "Local de destino", field: "destination", flex: 1, comparator: aggridUtils.nullLastComparator},
        {headerName: "Solicitante", field: "requester", flex: 1, comparator: aggridUtils.nullLastComparator},
    ];

    const { data: assetsTransfer, isLoading } = useQuery({
        queryKey: ['assetsTransfer', filter],
        queryFn: () =>  assetTransferService.list(filter).then(({data}) => data.data ?? []),
    });

    const clearFilter = () => {
        setState("")
        setFilter([]);
    }
    const apply = useCallback(() => {
        gridRef.current?.api?.showLoadingOverlay();

        setFilter({asset: state});
    }, [state]);
    const onChange = ({target: {value}}) => {
        setState(value)
    }
    const newTransfer = () => {
        let isBlank = false;
        let urlDev = `/asset-transfer/form`;
        navigate(urlDev, isBlank);
    }

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clearFilter);
    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Transferências entre locais</Template.Title>
                <Button onClick={() => newTransfer()}>
                    <FaPlus /> Adicionar transferência
                </Button>
            </Template.Header>
            <Template.Body className="flex flex-col space-y-2">
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12">
                            <div className="flex col-span-12 gap-4">
                                <InputForm classNameWrapper={"w-full"} id="search" value={state} onChange={onChange}
                                           label="Ativo"/>

                                <div className={"flex gap-2"}>
                                    <Button title="Limpar" onClick={() => clearFilter()} target={"primary-outline"}>
                                        <FaEraser/>
                                    </Button>
                                    <Button title="Buscar" onClick={() => apply()}>
                                        <FaSearch/>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={assetsTransfer}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={theme}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default AssetTransferList;